module.exports = __webpack_public_path__ + "static/media/uploadedVideoIcon.5ef0dfca.svg";